"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalProps = exports.useModal = exports.createModalContextProps = exports.createModalContext = void 0;
const react_1 = require("react");
const constants_1 = require("./constants");
const createModalContext = (id) => {
    if (!id)
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_INVALID_FROM_CONTEXT(id));
    if (contextMap.has(id))
        return contextMap.get(id);
    const context = (0, react_1.createContext)({});
    contextMap.set(id, context);
    return context;
};
exports.createModalContext = createModalContext;
const createModalContextProps = (id) => {
    if (!id)
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_INVALID_FROM_CONTEXT(id));
    if (contextPropsMap.has(id))
        return contextPropsMap.get(id);
    const contextProps = (0, react_1.createContext)({});
    contextPropsMap.set(id, contextProps);
    return contextProps;
};
exports.createModalContextProps = createModalContextProps;
const useModal = (id) => {
    if (!id)
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_INVALID_FROM(id, 'useModal'));
    if (!contextMap.has(id))
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_NOT_EXIST(id, 'useModal'));
    return (0, react_1.useContext)(contextMap.get(id));
};
exports.useModal = useModal;
const useModalProps = (id) => {
    if (!id)
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_INVALID_FROM(id, 'useModalProps'));
    if (!contextPropsMap.has(id))
        throw new Error(constants_1.ERROR_MESSAGES.MODAL_ID_NOT_EXIST(id, 'useModalProps'));
    return (0, react_1.useContext)(contextPropsMap.get(id));
};
exports.useModalProps = useModalProps;
const contextMap = new Map();
const contextPropsMap = new Map();
